var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 21C4 20.4477 4.44772 20 5 20H19C19.5523 20 20 20.4477 20 21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21Z",
    fill: "#009866"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4117 3.17449C13.9738 1.6124 16.5065 1.61241 18.0685 3.1745L18.8259 3.93186C20.388 5.49395 20.388 8.02662 18.8259 9.58872L11.9198 16.4948C11.6424 16.7722 11.2895 16.9619 10.905 17.0403L6.40144 17.9582C4.99689 18.2445 3.75606 17.0037 4.04229 15.5991L4.9601 11.0954C5.03845 10.7109 5.22816 10.358 5.50561 10.0805L12.4117 3.17449ZM16.6543 4.58872C15.8733 3.80767 14.607 3.80767 13.8259 4.58871L13.4143 5.00036L17 8.58614L17.4117 8.1745C18.1927 7.39345 18.1927 6.12712 17.4117 5.34607L16.6543 4.58872ZM8.41425 10.0003L12 6.41457L15.5858 10.0003L12 13.5861L8.41425 10.0003ZM7.00003 11.4146L6.91982 11.4948L6.00201 15.9985L10.5056 15.0806L10.5858 15.0003L7.00003 11.4146Z",
    fill: "#1C3D45"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditGreen);
export default __webpack_public_path__ + "static/media/edit_green.1afd9f9750b43d85fc6f9a5127209703.svg";
export { ForwardRef as ReactComponent };